import { type TurnOptions, turnOptionsSchema } from "@esi/shared";

/**
 * A question handed from home to a project, in the history entry's state: it lives in memory
 * only (never the URL or storage) and is taken once by the project's conversation panel.
 */
export interface QuestionHandoff {
  kind: "esi.ask";
  question: string;
  /** The effort picked on home (spec `model-choice`); the server re-resolves it anyway. */
  options?: TurnOptions;
}

export const handOffQuestion = (question: string, options?: TurnOptions): QuestionHandoff => ({
  kind: "esi.ask",
  question,
  ...(options && { options }),
});

/** The handed-off options, when well-formed; anything else is dropped. */
export function handedOffOptions(handoff: QuestionHandoff): TurnOptions | undefined {
  return turnOptionsSchema.safeParse(handoff.options).data;
}

export function isQuestionHandoff(value: unknown): value is QuestionHandoff {
  return (
    typeof value === "object" &&
    value !== null &&
    (value as QuestionHandoff).kind === "esi.ask" &&
    typeof (value as QuestionHandoff).question === "string" &&
    (value as QuestionHandoff).question.trim() !== ""
  );
}
